module.exports = __webpack_public_path__ + "static/media/ubicacion.2e8b6e97.png";